import { render } from "./MusicPlayer.vue?vue&type=template&id=3d8d8224&scoped=true"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"

import "./MusicPlayer.vue?vue&type=style&index=0&id=3d8d8224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8d8224"]])

export default __exports__